export default __webpack_public_path__ + "static/media/wanderingdisciple.63932f2a.png";